import { render, staticRenderFns } from "./QuoteLanding.vue?vue&type=template&id=78a6364b&"
import script from "./QuoteLanding.vue?vue&type=script&lang=js&"
export * from "./QuoteLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports